import React from 'react';
import { Accordion, Tabs, Tab, Table, Alert, Row, Col, Card, Button } from 'react-bootstrap';
import PropTypes from "prop-types";


function AccordionContents({ contents }) {
    return (
        <Row>
            <Col lg={12} xs={12}>
                <Accordion>
                    { contents.map((item, index) => {
                        return (
                            <Card key={item['region']}>
                                <Card.Header>
                                    <Accordion.Toggle as={Button}  eventKey={item['region']}>
                                       Region - { item['region'] } #
                                    </Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey={item['region']}>
                                    <Card.Body>
                                        <Tabs defaultActiveKey='region'>
                                            { Object.keys(item).map((subItem, subIndex) => (
                                                <Tab eventKey={subItem} title={subItem} key={subIndex}>
                                                    <Row>
                                                        <Col xg={12} ls={12}>
                                                            { item[subItem] instanceof Object ? (
                                                                <Table striped bordered hover>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>#</th>
                                                                            <th>Name</th>
                                                                            <th>Value</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {Object.keys(item[subItem]).map((element, eIndex) => (
                                                                            <tr key={eIndex}>
                                                                                <td>{eIndex}</td>
                                                                                <td>{element}</td>
                                                                                <td>{item[subItem][element]}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </Table>
                                                            ) :
                                                             <Alert variant='danger'>
                                                                { item[subItem] }
                                                             </Alert>}
                                                         </Col>
                                                     </Row>
                                                </Tab>)
                                            )}
                                        </Tabs>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        )
                    }) }
                </Accordion>
            </Col>
        </Row>
    )
}

AccordionContents.propTypes = {
    contents: PropTypes.array,
};

export default AccordionContents;